export type ServerBoundingRegion = {
	pageNumber: number;
	boxPosition: {
		x: number;
		y: number;
		width: number;
		height: number;
	};
};

export type SourcedBoundingRegion = ServerBoundingRegion & { sourceId: string };

export type RegionSource = 'server' | 'user';

export type Region = {
	id: string;
	sourceId: string;
	pageIndex: number;
	x: number;
	y: number;
	width: number;
	height: number;
	source: RegionSource;
};

export const createRegionId = () => `region-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const getLabelSourceId = (labelIndex: number) => `label-${labelIndex}`;
export const getCellSourceId = (tableIndex: number, rowIndex: number, columnIndex: number) =>
	`cell-${tableIndex}-${rowIndex}-${columnIndex}`;

export const boundingRegionsToRegions = (boundingRegions: SourcedBoundingRegion[]): Region[] =>
	boundingRegions.map((region) => ({
		id: createRegionId(),
		sourceId: region.sourceId,
		pageIndex: region.pageNumber - 1,
		x: region.boxPosition.x,
		y: region.boxPosition.y,
		width: region.boxPosition.width,
		height: region.boxPosition.height,
		source: 'server',
	}));

export const regionsToBoundingRegions = (regions: Region[]): ServerBoundingRegion[] =>
	regions.map((region) => ({
		pageNumber: region.pageIndex + 1,
		boxPosition: {
			x: region.x,
			y: region.y,
			width: region.width,
			height: region.height,
		},
	}));
